import Employee from '@/models/Employee';
import Employer from '@/models/Employer';

const batman: Employer = new Employer();
batman.firstName = 'Bruce';
batman.lastName = 'Wayne';
batman.description = `Need a driver or help you gliding through buildings? I am the man!`;
batman.availableTasks = [];
batman.rating = 3;
batman.photo = 'batman.png';
batman.email = 'ayokerja.batman@gmail.com';
batman.ktp = '111';
batman.contactInfo = {
  street: '123 Main St',
  city: 'Chicago',
  zipcode: '60606',
  phone: '1234567890'
};
export { batman };

export const robin = new Employee();
robin.firstName = 'Robin';
robin.lastName = 'Hood';
robin.description = `I can shoot arrows and steal stuff for ye!`;
robin.skills = [{ name: 'Shooting arrows', level: 10, rate: 1 }, { name: 'Stealing', level: 15, rate: 1 }];
robin.rating = 3;
robin.photo = 'robinhood.png';
robin.email = 'ayokerja.robinhood@gmail.com';
robin.ktp = '111';
robin.contactInfo = {
  street: '123 Main St',
  city: 'Chicago',
  zipcode: '60606',
  phone: '1234567890'
};

export const ryu = new Employee();
ryu.firstName = 'Ryu';
ryu.lastName = 'Hayabusa';
ryu.description = `I can climb trees and throw shurikens. Hire me!`;
ryu.skills = [{ name: 'Climbing tree', level: 20, rate: 100 }, { name: 'Throwing shurikens', level: 25, rate: 100 }];
ryu.rating = 3;
ryu.photo = 'ninja.png';
ryu.email = 'ayokerja.ninja@gmail.com';
ryu.ktp = '111';
ryu.contactInfo = {
  street: '123 Main St',
  city: 'Chicago',
  zipcode: '60606',
  phone: '1234567890'
};
export const employees = [robin, ryu];
